import { render, staticRenderFns } from "./AttachmentChips.vue?vue&type=template&id=41ad208d&scoped=true"
import script from "./AttachmentChips.vue?vue&type=script&lang=js"
export * from "./AttachmentChips.vue?vue&type=script&lang=js"
import style0 from "./AttachmentChips.vue?vue&type=style&index=0&id=41ad208d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ad208d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ad208d')) {
      api.createRecord('41ad208d', component.options)
    } else {
      api.reload('41ad208d', component.options)
    }
    module.hot.accept("./AttachmentChips.vue?vue&type=template&id=41ad208d&scoped=true", function () {
      api.rerender('41ad208d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/AttachmentChips.vue"
export default component.exports